// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle__black{background:#000;border:1px solid #000;border-radius:50%;height:8px;width:8px}.circle__white{border:1px solid #cacaca;border-radius:50%;height:8px;width:8px}.divider{border-bottom:1px solid #cacaca}.divider,.divider__black{align-self:center;height:1px;margin-left:4px;margin-right:4px;width:15px}.divider__black{border-bottom:1px solid #000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
